export default {
    state: {
        url: '',
        uuid: '',
        fields: [],
    },
    mutations: {
        SET_URL(state, url) {
            state.url = url;
        },
        SET_UUID(state, uuid){
            state.uuid = uuid;
        },
        SET_FIELDS(state, fields){
            state.fields = fields;
        }
    },
    actions: {
        setUrl({ commit }, url){
            commit("SET_URL", url);
        },
        setUuid({ commit }, uuid){
            commit("SET_UUID", uuid);
        },
        setFields({ commit }, fields){
            commit("SET_FIELDS", fields);
        }
    }
}